export default __webpack_public_path__ + "media/images/home/slide_participation_request_lg-63abc33c7a1f6bba3ef857ad85854622.jpg";